module.exports = __webpack_public_path__ + "img/webBrand--billy-dash-wh.2450378a.svg";